// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'FrederickSimms', 'FrederickSimms Fallback', Objektiv, sans-serif"},"className":"__className_8991f4","variable":"__variable_8991f4"};